import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { UserAuthApiService } from '../../../../shared/services/auth/user-auth-api.service';

@Component({
    selector: 'app-public-header',
    standalone: true,
    imports: [CommonModule, RouterModule, MatToolbarModule, MatButtonModule, MatDividerModule],
    templateUrl: './public-header.component.html',
    styleUrls: ['./public-header.component.scss']
})
export class PublicHeaderComponent implements OnInit {
    private readonly userAuthApiService = inject(UserAuthApiService);
    private readonly router = inject(Router);

    readonly isAuthenticated = signal(false);

    ngOnInit(): void {
        this.performAuthCheck(false);
    }

    onLogoClick(): void {
        // Check auth state when logo is clicked and navigate accordingly
        this.performAuthCheck(true);
    }

    private performAuthCheck(shouldNavigate: boolean): void {
        this.userAuthApiService.checkAuth().subscribe({
            next: (isAuth) => {
                this.isAuthenticated.set(isAuth);
                if (shouldNavigate) {
                    const route = isAuth ? '/deliveries-dashboard' : '/login';
                    this.router.navigate([route]);
                }
            },
            error: () => {
                this.isAuthenticated.set(false);
                if (shouldNavigate) {
                    this.router.navigate(['/login']);
                }
            }
        });
    }
}
